export default __webpack_public_path__ + "4b8c9c5048884f6750e1a802bea24201.png";